<template>
  <div class="articles uk-container">
    <article class="uk-article" v-if="article.content">
      <h1 class="uk-article-title">{{article.title.rendered}}</h1>
      <p class="uk-article-meta">by
        <a href="#">아이스 </a>
        <span class="day"
              v-if="moment(article.date).add(3, 'days') > moment()">{{moment(article.date).fromNow()}}</span>
        <span class="day" v-else>{{moment(article.date).format('LL')}}</span>
        <a href="#"> Blog</a></p>
      <!-- <p class="uk-text-lead">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> -->
      <div v-html="replaceImgHW(article.content.rendered)"></div>
    </article>
    <!-- <div class="comments">
      <div class="uk-grid-small uk-child-width-auto" uk-grid>
        <div>
          <a class="uk-button uk-button-text" href="#">Read more</a>
        </div>
        <div>
          <a class="uk-button uk-button-text" href="#">5 Comments</a>
        </div>
      </div> -->
    <!-- SNS 댓글 -->
    <!-- <vue-disqus shortname="fm3647" :identifier="article.id" url="https://localhost:8080"></vue-disqus> -->
    <!-- <vue-disqus shortname="fm3647" :identifier="article.id" url="https://fm3647.disqus.com/embed.js"></vue-disqus> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'Article',
  data () {
    return {
      apiUrl: 'https://api.suuon.net/wp-json/wp/v2/posts/',
      article: {},
      id: this.$route.query.id
    }
  },
  created () {
    this.getArticle()
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    'this.id': 'getArticle'
  },
  methods: {
    getArticle () {
      // GET /someUrl
      this.$http.get(this.apiUrl + this.id).then(response => {
        // get body data
        response = response.body
        this.article = response
        // alert(response);
        // console.log(this.article);
        // alert(this.id)
      })
    },
    replaceImgHW (strs) {
      var st1 = strs.replace(/ height="\d+"/g, '')
      var st2 = st1.replace(/ width="\d+"/g, '')
      var st3 = st2.replace(/width: \d+px/g, '')
      var st4 = st3.replace(/ style/g, '')
      var st5 = st4.replace(/=""/g, '')
      var st = st5.replace(/href=/g, 'target="_blank" href=')
      return st
    }
  }
}
</script>
